import { GATES } from '../constants/auth';
import { useGetIsUngated } from './useGetIsUngated';
import { useHasQuotesTeamBeta } from './useHasQuotesTeamBeta';
export const useHasSeqReqChangesRedesign = () => {
  const getIsUngated = useGetIsUngated();
  // ChangesRequestedAndStages always gets the redesign; the AgentApprover gate
  // deliberately does NOT (agent-only portals keep the legacy DND ordered-stages
  // flow). Quotes needs the redesign for their team-based-approvals beta, so the
  // commerce:qmgmt:TeamBasedApprovals gate opts users into it as well.
  const hasQuotesTeamBeta = useHasQuotesTeamBeta();
  return getIsUngated(GATES.CHANGES_REQUESTED_AND_STAGES) || hasQuotesTeamBeta;
};